import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pictures/user_invite.png'


const _hoisted_1 = { class: "send-nft-confirm-comp" }
const _hoisted_2 = { class: "text-box" }
const _hoisted_3 = { class: "button-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mv_button = _resolveComponent("mv-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "img-box" }, [
      _createElementVNode("img", { src: _imports_0 })
    ], -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('receiveNtfc.userInvite.text', [_ctx.info.email])), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_mv_button, {
        type: "round-black",
        text: "common.ok",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ok')))
      })
    ])
  ]))
}